import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Chat    from '../user/Chat';
import Offers  from '../user/Offers';
import Games   from '../user/Games';
import Profile from '../user/Profile';

const NAV = [
  { id: 'chat',    icon: '💬', label: 'Support' },
  { id: 'offers',  icon: '🎁', label: 'Offers' },
  { id: 'games',   icon: '🎮', label: 'Games' },
  { id: 'profile', icon: '👤', label: 'Profile' },
];

export default function UserApp() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [active, setActive]     = useState('chat');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleLogout = () => { logout(); navigate('/login', { replace: true }); };
  const getInitials  = (name = '') => name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);

  const renderPage = () => {
    if (active === 'chat')    return <Chat />;
    if (active === 'offers')  return <Offers />;
    if (active === 'games')   return <Games />;
    if (active === 'profile') return <Profile />;
  };

  return (
    <div style={s.root}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Rajdhani:wght@700&family=Exo+2:wght@400;600;700;900&display=swap');
        *,*::before,*::after{box-sizing:border-box;}
        ::-webkit-scrollbar{width:4px} ::-webkit-scrollbar-thumb{background:rgba(245,166,35,.2);border-radius:4px}
        .unav:hover{background:rgba(245,166,35,.06)!important;color:rgba(255,255,255,.8)!important}
      `}</style>

      {!isMobile && (
        <div style={s.sidebar}>
          <div style={s.brand}>
            <img src="/logo.jpg" alt="MegaFishHub" style={{ height: '42px', width: 'auto', objectFit: 'contain' }} />
          </div>
          <div style={s.userCard}>
            <div style={s.userAvatar}>{getInitials(user?.name)}</div>
            <div style={{ minWidth: 0 }}>
              <div style={s.userName}>{user?.name || 'Player'}</div>
              <div style={s.userEmail}>{(user?.email || '').slice(0, 22)}{(user?.email || '').length > 22 ? '…' : ''}</div>
              {user?.isVip && <div style={s.vipBadge}>⭐ VIP</div>}
            </div>
          </div>
          <nav style={s.nav}>
            {NAV.map(item => (
              <button key={item.id} className="unav" onClick={() => setActive(item.id)}
                style={{ ...s.navItem, ...(active === item.id ? s.navActive : {}) }}>
                <span style={{ fontSize: '18px', width: '22px' }}>{item.icon}</span>
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
          <button style={s.logoutBtn} onClick={handleLogout}>⏻ &nbsp;Logout</button>
        </div>
      )}

      {isMobile && (
        <div style={s.mobileTop}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '7px', fontSize: '18px' }}>
            <img src="/logo.jpg" alt="MegaFishHub" style={{ height: '36px', width: 'auto', objectFit: 'contain' }} />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {user?.isVip && <span style={s.mobileVip}>⭐ VIP</span>}
            <button style={s.mobileLogout} onClick={handleLogout}>⏻</button>
          </div>
        </div>
      )}

      <div style={{ ...s.main, ...(isMobile ? s.mainMobile : {}) }}>
        {renderPage()}
      </div>

      {isMobile && (
        <div style={s.bottomNav}>
          {NAV.map(item => (
            <button key={item.id} onClick={() => setActive(item.id)}
              style={{ ...s.bottomTab, ...(active === item.id ? s.bottomTabActive : {}) }}>
              <span style={{ fontSize: '22px' }}>{item.icon}</span>
              <span style={{ fontSize: '9px', marginTop: '2px' }}>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  root: { display: 'flex', height: '100vh', overflow: 'hidden', background: '#080c14', fontFamily: "'Exo 2',sans-serif" },
  sidebar: { width: '210px', minWidth: '210px', background: '#0d1420', borderRight: '1px solid rgba(245,166,35,.1)', display: 'flex', flexDirection: 'column', height: '100vh', flexShrink: 0 },
  brand: { display: 'flex', alignItems: 'center', gap: '9px', padding: '18px 14px', borderBottom: '1px solid rgba(245,166,35,.08)' },
  brandText: { fontFamily: "'Rajdhani',sans-serif", fontSize: '19px', fontWeight: '700', color: '#f5a623', letterSpacing: '5px' },
  userCard: { display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', margin: '10px', borderRadius: '12px', background: 'rgba(245,166,35,.04)', border: '1px solid rgba(245,166,35,.08)' },
  userAvatar: { width: '36px', height: '36px', borderRadius: '10px', background: 'linear-gradient(135deg,#f5a623,#00aaff)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#080c14', fontSize: '13px', fontWeight: '900', flexShrink: 0 },
  userName: { color: '#e2e8f0', fontSize: '13px', fontWeight: '600', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  userEmail: { color: 'rgba(255,255,255,.3)', fontSize: '10px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  vipBadge: { background: 'rgba(255,215,0,.12)', border: '1px solid rgba(255,215,0,.3)', color: '#ffd700', borderRadius: '5px', padding: '1px 6px', fontSize: '9px', fontWeight: '700', marginTop: '3px', display: 'inline-block' },
  nav: { flex: 1, padding: '8px', display: 'flex', flexDirection: 'column', gap: '2px' },
  navItem: { display: 'flex', alignItems: 'center', gap: '10px', padding: '11px 12px', borderRadius: '11px', border: 'none', background: 'transparent', color: 'rgba(255,255,255,.4)', cursor: 'pointer', textAlign: 'left', width: '100%', fontSize: '13px', fontWeight: '600', fontFamily: "'Exo 2',sans-serif", transition: 'all .15s' },
  navActive: { background: 'rgba(245,166,35,.08)', color: '#f5a623', borderLeft: '3px solid #f5a623' },
  logoutBtn: { margin: '12px', background: 'rgba(255,50,50,.07)', border: '1px solid rgba(255,50,50,.15)', borderRadius: '10px', color: '#ff6b6b', padding: '10px', cursor: 'pointer', fontSize: '13px', fontFamily: "'Exo 2',sans-serif" },
  mobileTop: { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, height: '52px', background: '#0d1420', borderBottom: '1px solid rgba(245,166,35,.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 16px' },
  mobileVip: { background: 'rgba(255,215,0,.12)', border: '1px solid rgba(255,215,0,.3)', color: '#ffd700', borderRadius: '5px', padding: '2px 8px', fontSize: '10px', fontWeight: '700' },
  mobileLogout: { background: 'rgba(255,50,50,.08)', border: '1px solid rgba(255,50,50,.15)', borderRadius: '8px', color: '#ff6b6b', fontSize: '15px', cursor: 'pointer', padding: '5px 9px' },
  main: { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' },
  mainMobile: { paddingTop: '52px', paddingBottom: '60px' },
  bottomNav: { position: 'fixed', bottom: 0, left: 0, right: 0, height: '60px', background: '#0d1420', borderTop: '1px solid rgba(245,166,35,.1)', display: 'flex', zIndex: 100 },
  bottomTab: { flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: 'none', color: 'rgba(255,255,255,.3)', cursor: 'pointer', fontFamily: "'Exo 2',sans-serif", transition: 'all .15s' },
  bottomTabActive: { color: '#f5a623', background: 'rgba(245,166,35,.05)' },
};
